import {RequestFulfillment, RequestFulfillmentDefinition} from './FulfillmentConstants';

export const fulfillmentMatchesDefinition = (
  fulfillment: RequestFulfillment,
  fulfillmentDefinition: RequestFulfillmentDefinition
): boolean =>
  fulfillment.requestId === fulfillmentDefinition.requestId &&
  fulfillment.sampleGroupId === fulfillmentDefinition.sampleGroupId &&
  fulfillment.requestTaskId === fulfillmentDefinition.requestTaskId;
